<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script setup>
import feather from 'feather-icons';
import { onMounted } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

onMounted(async () => {
  feather.replace();
  window.scrollTo(0, 0);

  // await $store.dispatch('');
  //
  // // console.log($store.state.products);
});
</script>

<style></style>